import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ChatService } from '../../service/chat-service';
import { InteractionService } from '../../service/interaction/interaction.service';
import { ChatRegionMarketService } from '../../v2/modules/roleplay/services/chat-region-market.service';
import { CreateBugComponent } from '../ContactCenter/create-bug/create-bug.component';
import { SurveyConfigurationService } from '../../v2/services/admin/survey-configuration/survey-configuration.service';
import { PlatformRegionService } from '../../service/shared/platform-region.service';
import { UserService } from '../../service/shared/user-service.service';

@Component({
    selector: 'app-help-doc-content',
    templateUrl: './help-doc-content.component.html',
    styleUrls: ['./help-doc-content.component.scss'],
    standalone: false
})
export class HelpDocContentComponent implements OnInit {

  helpData: any;
  title: string;
  surveyLink: string | null = null;

  get isAdmin(): boolean {
    const role = (sessionStorage.getItem('role') || '').toUpperCase();
    return role === 'TRAINER' || role === 'SUPERVISOR';
  }

  constructor(
    private readonly chatService: ChatService,
    public intService: InteractionService,
    private readonly chatRegionMarketService: ChatRegionMarketService,
    private readonly platformRegionService: PlatformRegionService,
    private readonly surveyConfigurationService: SurveyConfigurationService,
    private dialog: MatDialog,
    private router: Router,
    private userService: UserService
  ) { }

  ngOnInit(): void {
    this.intService.activeMenu.next('');
    this.chatService.getJSON().subscribe(data => {
      const bUnit = sessionStorage.getItem('businessUnit');
      const businessUnitCode = sessionStorage.getItem('businessUnitCode');
      const region = this.chatRegionMarketService.selected_region_code;
      const product = data.products.find((item: any) => item.businessUnitCode === businessUnitCode && item.region === region);
      this.helpData = product;
      this.title = data.title + ' - ' + bUnit;
    });

    this.loadSurveyLink();
  }

  private loadSurveyLink(): void {
    const bu = this.platformRegionService.selected_platform_code || sessionStorage.getItem('businessUnitCode') || '';
    const region = this.platformRegionService.selected_region_code || this.chatRegionMarketService.selected_region_code || '';

    if (!bu || !region || !this.userService.isTraineeUser()) return;

    this.surveyConfigurationService.getSurveyLink(bu, region).subscribe({
      next: (res) => { this.surveyLink = res.survey_link; }
    });
  }

  openSubmitIssueDialog(): void {
    sessionStorage.setItem('requestListSelectedTab', '2');
    this.router.navigate(['/app-request-list'], { skipLocationChange: true });
    setTimeout(() => {
      const dialogRef = this.dialog.open(CreateBugComponent, {
        width: '600px',
        disableClose: true,
        panelClass: 'create-bug-dialog-container',
        data: { type: 'general_questions' }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          // stay on general questions tab after submission
        }
      });
    });
  }

}
